// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"526":"1ee99ba262ff3f1d","1711":"25c246b98eecf414"}[chunkId] + ".css";
};